document.addEventListener('DOMContentLoaded', () => {
  const searchForm = document.getElementById('main_blog_search');
  const articlesGrid = document.getElementById('main_blog_articles_result');

  const tagButtons = document.querySelectorAll('.blog-tags .button');

  searchForm?.addEventListener('submit', event => {
    event.preventDefault();
    searchResults();
  });

  tagButtons.forEach(button => {
    button.addEventListener('click', () => {
      tagButtons.forEach(subButton => {
        if (button != subButton) {
          subButton.classList.remove('button--solid');
          subButton.removeAttribute('data-tag-active');
        }
      });
      button.classList.add('button--solid');
      button.setAttribute('data-tag-active', true);

      searchResults();
    });
  });

  function searchResults() {
    const searchInput = searchForm.querySelector('input[name="q"]');
    const searchText = searchInput.value != '' ? searchInput.value : '*';

    const activeTag = document.querySelector('[data-tag-active]')?.getAttribute('data-tag-content');
    const tagContent = activeTag != '' ? `"${activeTag}"` : '';

    const querryText = `${searchText}, ${tagContent}`;

    fetch(`/search?q=${querryText}&type=article`)
      .then(data => data.text())
      .then(data => {
        const articlesList = new DOMParser()
          .parseFromString(data, 'text/html')
          .getElementById('article_search_results').innerHTML;
        articlesGrid.innerHTML = articlesList;
      })
      .catch(error => {
        const noResultsLabel = document.querySelector('.main-blog__no-results');
        if (noResultsLabel) articlesGrid.innerHTML = `<p class="h5">${noResultsLabel.innerHTML}</p>`;
      });
  }
});
